namespace $ {

	/** Signed intent distinguishes personal public-read grants from fallback revocations. */
	export class $shm_hitalama_map_access_grant extends $mol_object {

		static head( recipient: string ) {
			return this.$.$giper_baza_link.hash_str( 'map-personal-grant:v1:' + recipient ).peer()
		}

		static status( map: $giper_baza_land, recipient: string ): boolean | null {
			const gift = map._gift.get( recipient )
			if( !gift ) return null
			let latest = -1, status: boolean | null = null
			for( const sand of this.$.$shm_hitalama_map_access_index.authored_units( map, this.head( recipient ) ) ) {
				if( map.lord_rank( sand.lord() ) < this.$.$giper_baza_rank_rule ) continue
				map.sands_open([ sand ])
				const data = map.sand_decode( sand )
				if( !Array.isArray( data ) || data.length !== 4 || data[0] !== 1 || data[1] !== recipient
					|| data[2] !== gift.time_tick() || typeof data[3] !== 'boolean' ) continue
				if( sand.time_tick() <= latest ) continue
				latest = sand.time_tick()
				status = data[3]
			}
			return status
		}

		@ $mol_action
		static record( map: $giper_baza_land, recipient: string, active: boolean ) {
			const issuer = map.auth().pass().lord()
			if( map.lord_rank( issuer ) < this.$.$giper_baza_rank_rule ) $mol_fail( new Error( 'Only a map administrator can record a personal grant' ) )
			const gift = map._gift.get( recipient )
			if( !gift ) $mol_fail( new Error( 'Personal grant marker requires a signed Gift' ) )
			if( active && gift.rank() < this.$.$giper_baza_rank_read ) {
				$mol_fail( new Error( 'Grant map access before recording a personal invitation' ) )
			}
			const head = this.head( recipient )
			const self = this.$.$giper_baza_link.hash_str( 'map-personal-grant:v1' ).peer()
			const data = [ 1, recipient, gift.time_tick(), active ]
			const previous = map.sand_get( head, issuer, self )
			if( previous && !previous.dead() ) {
				map.sands_open([ previous ])
				if( JSON.stringify( map.sand_decode( previous ) ) === JSON.stringify( data ) ) return false
			}
			map.post( this.$.$giper_baza_link.hole, head, self, data )
			return true
		}

	}

}
